<div class="ui-kit-playground">
  <h3 class="ui-kit-playground__title">Alert</h3>

  <div class="ui-kit-playground__controls">
    <label class="ui-kit-playground__control">
      <span class="ui-kit-playground__label">Type</span>
      <select [(ngModel)]="type" class="form-control">
        <option value="info">info</option>
        <option value="warning">warning</option>
        <option value="error">error</option>
      </select>
    </label>

    <label class="ui-kit-playground__control">
      <span class="ui-kit-playground__label">Width</span>
      <select [(ngModel)]="widthLayout" class="form-control">
        <option value="fixed">fixed (328)</option>
        <option value="fill">fill</option>
      </select>
    </label>

    <label class="ui-kit-playground__control ui-kit-playground__control--checkbox">
      <input type="checkbox" [(ngModel)]="showDescription" />
      <span class="ui-kit-playground__label">Show description</span>
    </label>

    <label class="ui-kit-playground__control">
      <span class="ui-kit-playground__label">Emphasis</span>
      <input [(ngModel)]="emphasisText" class="form-control" />
    </label>

    <label class="ui-kit-playground__control">
      <span class="ui-kit-playground__label">Description</span>
      <input [(ngModel)]="description" class="form-control" />
    </label>
  </div>

  <div class="ui-kit-playground__preview">
    <common-alert
      [type]="type"
      [emphasisText]="emphasisText"
      [description]="description"
      [showDescription]="showDescription"
      [widthLayout]="widthLayout"
    ></common-alert>
  </div>
</div>

